// libs
import { styled } from '@nykaa/ui-components';

// constants
import { PROBE_HEIGHT, PROBE_WIDTH, ZOOM_HEIGHT, ZOOM_WIDTH } from './constants';

export const ZoomContainer = styled.div`
  position: absolute;
  z-index: 5;
  cursor: crosshair;

  .zm-probe {
    position: absolute;
    height: ${PROBE_HEIGHT}px;
    width: ${PROBE_WIDTH}px;
    background: rgba(255, 255, 255, 0.5);
  }

  .zm-image-cnt {
    position: absolute;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    right: ${-1 * (ZOOM_WIDTH + 20)}px;
    top: 0;
    height: ${ZOOM_HEIGHT}px;
    width: ${ZOOM_WIDTH}px;
    overflow: hidden;
  }

  .zm-image {
    position: absolute;
    display: block;
  }
`;
